import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  useLiquidityFilterActions,
  useLiquidityFilterState,
} from '@paradigm/features/src/leaderboard/contexts/liquidity-filter';

import { TabContainer } from '#/components/Leaderboard/shared/components';
import FilterModal from '#/components/Leaderboard/shared/FilterModal';
import FilterForm from '#/components/Leaderboard/shared/FilterForm';
import LiquidityFillsTable from '#/components/Leaderboard/liquidity/LiquidityFillsTable';
import { useLiquidityFillsState } from '@paradigm/features/src/leaderboard/contexts/liquidity-fills-list';

export default function LiquidityFillsTab() {
  const isMobile = useIsMobile();
  const actions = useLiquidityFilterActions();
  const state = useLiquidityFilterState();
  const { lastUpdatedAt } = useLiquidityFillsState();

  return (
    <TabContainer data-testid="leaderboard-liquidity-fills-tab">
      {!isMobile && (
        <FilterForm
          lastUpdatedAt={lastUpdatedAt}
          actions={actions}
          state={state}
          hasStrategyField
          filterType="liquidity"
        />
      )}
      <LiquidityFillsTable />
      <FilterModal
        lastUpdatedAt={lastUpdatedAt}
        actions={actions}
        state={state}
        hasStrategyField
        filterType="liquidity"
      />
    </TabContainer>
  );
}
